<template>
    <div class="sui-load" :style="{ 'color': mColor(3) }">
        <template v-if="more"><sui-icon :style="{ 'fill': mColor(3) }" name="loading"></sui-icon>加载中</template>
        <div v-else>— 我也是有底线的 —</div>
    </div>
</template>

<script>
import Mixin from '../../scripts/mixin'
import SuiIcon from '../icon/icon'

export default {
    name: 'sui-load',

    mixins: [Mixin],

    components: {
        SuiIcon
    },

    props: {

        // 是否还有更多
        more: {
            type: Boolean,
            default: true
        },

        // 自定义主题色
        colors: {
            type: Object,
        }
    },
}
</script>

<style lang="postcss">
.sui-load {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
    font-size: 12px;
    @media (max-aspect-ratio: 1/2) {
        padding-bottom: var(--safe-area-inset-bottom);
    }
    @media (min-aspect-ratio: 2/1) {
        padding-bottom: var(--safe-area-inset-bottom);
    }
    .sui-icon {
        width: 14px;
        height: 14px;
        margin-right: 3px;
        animation: 1s linear infinite rotate;
    }
}
@keyframes rotate {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
